// extracted by mini-css-extract-plugin
export default {"Guide":"Guide_Guide__vORAV","Privacy":"Guide_Privacy__xQXzQ","Refund":"Guide_Refund__xFyp2","Tos":"Guide_Tos__DkCux","nonScrollBox":"Guide_nonScrollBox__WkpT6"};